import { Tag } from '@cian/components';
import * as React from 'react';

import { IDeveloperTag } from '../../../state/tags/definitions/developer';
import { TagNew } from '../TagNew';

import { tagThemeSmall } from '../tag_theme';

export interface IDeveloperTagItemProps {
  tag: IDeveloperTag;
  withNewTag?: boolean;
  onDeleteClick(): void;
}

export const DeveloperTagItem = ({ onDeleteClick, tag, withNewTag }: IDeveloperTagItemProps) => {
  const TagComponent = React.useMemo(() => (withNewTag ? TagNew : Tag), [withNewTag]);

  return (
    <TagComponent onDeleteClick={onDeleteClick} tagStyles={tagThemeSmall}>
      {tag.value ? 'От застройщиков' : 'От агентов и частных лиц'}
    </TagComponent>
  );
};
